import React, { Component, Fragment } from 'react';
// import { Link } from "react-router-dom";
import LogRocket from 'logrocket';

import Modal from '../../common/Modal';
import LargeCheckmarkIcon from '../../icons/LargeCheckmarkIcon';
import InputErrors from '../../common/InputErrors';
import CheckboxIcon from '../../icons/CheckboxIcon';

class BugReporterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      emailMe: false,
      showSuccess: false,
      serverErrors: [],
    };
  }

  handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const { name } = e.target;

    this.setState({ [name]: value });
  }

  submit = (e) => {
    const { emailMe, message } = this.state;
    const { bugReportsActions } = this.props;

    e.preventDefault();
    this.resetErrors();
    LogRocket.getSessionURL((url) => {
      bugReportsActions.submitBugReport({
        logUrl: url,
        emailMe,
        message,
      }, this.onSuccess, this.onFail);
    });
  }

  onSuccess = () => {
    this.setState({
      message: '',
      emailMe: false,
      showSuccess: true,
    }, () => {
      document.querySelector('.ReactModal__Content').focus(); // keep focus inside the modal
    });
  }

  onFail = (error) => {
    // TO DO: Show errors in form
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  resetErrors = () => {
    this.setState({ serverErrors: [] });
  }

  closeModal = () => {
    const { toggleBugReporterModal } = this.props;
    this.resetErrors();
    this.setState({ showSuccess: false });
    toggleBugReporterModal();
  }

  render() {
    const { serverErrors, showSuccess, message, emailMe } = this.state;
    const { visible } = this.props;

    return (
      <Modal
        toggleModal={this.closeModal}
        visible={visible}
        centered
      >
        {showSuccess
          ? (
            <div className="text">
              <h2>
                Your Report Has
                <br />
                Been Sent
              </h2>
              <div className="modal__checkmark-icon">
                <LargeCheckmarkIcon />
              </div>
              <button
                type="button"
                onClick={this.closeModal}
                className="button"
              >
                Back to Help
              </button>
            </div>
          ) : (
            <Fragment>
              <div className="text">
                <h2>
                  Submit a Bug Report
                </h2>
                <p>
                  No sensitive information about your account will be included in the report.
                </p>
              </div>
              <form className="form form--modal">
                {serverErrors.length !== 0 && <InputErrors errors={serverErrors} /> }
                <label className="form__text-label" htmlFor="input-message">
                  Description of Your Issue:
                </label>
                <textarea
                  id="input-message"
                  name="message"
                  value={message}
                  onChange={this.handleChange}
                />
                <div className="form__checkbox-wrapper">
                  <label className="form__checkbox">
                    <input
                      name="emailMe"
                      type="checkbox"
                      value={emailMe}
                      onChange={this.handleChange}
                    />
                    <CheckboxIcon value={emailMe} lightUi />
                    Please follow up with me via email
                  </label>
                </div>
                {/*
                  <div className="form__options">
                    <Link to='/forgot-password' className="flat-link">
                      Forgot password?
                    </Link>
                  </div>
                */}
                <div className="form__submit-button-wrapper">
                  <button
                    type="submit"
                    onClick={this.submit}
                    className="button"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </Fragment>
          )}
      </Modal>
    );
  }
}

export default BugReporterModal;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/BugReporterModal.js